import { mapActions } from 'vuex';

export default {
  name: 'ClearCartDialog',
  props: {
    curName: {
      default: '',
      type: String,
    },
    item: {
      required: true,
      type: Object,
    },
    oriName: {
      default: '',
      type: String,
    },
    value: Boolean,
  },
  methods: {
    ...mapActions('cart', {
      clearCartItems: 'CLEAR_CART_ITEMS',
      setCartItem: 'SET_CART_ITEM',
    }),
    ...mapActions('menu', {
      clearCartMenu: 'CLEAR_CART_MENU',
    }),
    clear() {
      this.clearCartItems();
      this.clearCartMenu();
      this.setCartItem(this.item);

      this.$emit('close-details');
      this.close();
    },
    close() {
      this.$emit('close');
    },
  },
};
